import { render, staticRenderFns } from "./AssetCreate.vue?vue&type=template&id=6a645a46&scoped=true"
import script from "./AssetCreate.vue?vue&type=script&lang=js"
export * from "./AssetCreate.vue?vue&type=script&lang=js"
import style0 from "./AssetCreate.vue?vue&type=style&index=0&id=6a645a46&prod&lang=scss"
import style1 from "./AssetCreate.vue?vue&type=style&index=1&id=6a645a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a645a46",
  null
  
)

export default component.exports